export default [
  {
    name: 'repayApply',
    method: 'post',
    url: '/finhub/front/repay/toRepay',
  },
]
